import { LocalizationHelper } from '../../shared/helpers/localization/localization.helper';

type Keys =
  | 'statistic'
  | 'order_statistic'
  | 'charts'
  | 'show_one_time_customers'
  | 'product_group'
  | 'marketing_group'
  | 'group_by'
  | 'order_type'
  | 'chart_type'
  | 'production_group'
  | 'production_statistic'
  | 'revenue'
  | 'quantity_by_order_type'
  | 'articles_sold'
  | 'top_article'
  | 'best_customer'
  | 'calculate'
  | 'profile'
  | 'add_and_customize'
  | 'profile_name'
  | 'revenue_after_discount'
  | 'revenue_after_discount_hint'
  | 'revenue_pre_discount'
  | 'revenue_pre_discount_hint'
  | 'produced_articles'
  | 'total_price'
  | 'raw_material'
  | 'total_dough_produced'
  | 'produced_dough_kinds'
  | 'top_dough'
  | 'total_raw_materials_used'
  | 'used_raw_material_kinds'
  | 'top_raw_material';

const t = LocalizationHelper<Keys>('statistic');

export const statisticDe = t({
  statistic: 'Statistik',
  order_statistic: 'Bestellstatistik',
  product_group: 'Warengruppe',
  marketing_group: 'Marketing-Gruppe',
  production_group: 'Produktionsgruppe',
  production_statistic: 'Produktionsstatistik',
  group_by: 'Gruppiert nach',
  order_type: 'Bestelltyp',
  show_one_time_customers: 'Einmalkunden anzeigen',
  chart_type: 'Diagrammtyp',
  charts: 'Diagramme',
  revenue: 'Umsatz',
  quantity_by_order_type: 'Anzahl nach Bestelltyp',
  articles_sold: 'Verkaufte Artikel',
  top_article: 'Top-Artikel',
  best_customer: 'Bester Kunde',
  calculate: 'Berechnen',
  profile: 'Profil',
  add_and_customize: 'Hinzufügen & Anpassen',
  profile_name: 'Profilname',
  revenue_after_discount: 'Umsatz (n. Rab.)',
  revenue_after_discount_hint: 'Umsatz nach Rabatt, exkl. MwSt',
  revenue_pre_discount: 'Umsatz (v. Rab.)',
  revenue_pre_discount_hint: 'Umsatz vor Rabatt, exkl. MwSt',
  produced_articles: 'Artikel hergestellt',
  total_price: 'Gesamtpreis',
  raw_material: 'Rohmaterial',
  total_dough_produced: 'Gesamter produzierter Teig',
  produced_dough_kinds: 'Hergestellte Teigarten',
  top_dough: 'Top-Teig',
  total_raw_materials_used: 'Gesamte verwendete Rohmaterialen',
  used_raw_material_kinds: 'Verwendete Rohmaterialen',
  top_raw_material: 'Top-Rohmaterial',
});

export const statisticEn = t({
  statistic: 'Statistic',
  order_statistic: 'Order statistic',
  product_group: 'Product group',
  marketing_group: 'Marketing group',
  show_one_time_customers: 'Show one-time customers',
  production_group: 'Production group',
  production_statistic: 'Production statistic',
  group_by: 'Group by',
  order_type: 'Order type',
  chart_type: 'Chart type',
  charts: 'Charts',
  revenue: 'Revenue',
  articles_sold: 'Articles sold',
  quantity_by_order_type: 'Quantity by order type',
  top_article: 'Top article',
  best_customer: 'Best customer',
  calculate: 'Calculate',
  profile: 'Profile',
  add_and_customize: 'Add & Customize',
  profile_name: 'Profile name',
  revenue_after_discount: 'Revenue (disc.)',
  revenue_after_discount_hint: 'Revenue after discount, excl. VAT',
  revenue_pre_discount: 'Revenue (orig.)',
  revenue_pre_discount_hint: 'Revenue before discount, excl. VAT',
  produced_articles: 'Produced articles',
  total_price: 'Total price',
  raw_material: 'Raw material',
  total_dough_produced: 'Total dough produced',
  produced_dough_kinds: 'Produced dough kinds',
  top_dough: 'Top-dough',
  total_raw_materials_used: 'Total raw materials used',
  used_raw_material_kinds: 'Used raw material kinds',
  top_raw_material: 'Top-raw material',
});

export const statisticFr = t({
  statistic: 'Statistique',
  order_statistic: 'Statistique des commandes',
  product_group: 'Groupe de produits',
  show_one_time_customers: 'Afficher les clients uniques',
  marketing_group: 'Groupe marketing',
  production_group: 'Groupe de production',
  production_statistic: 'Statistique de production',
  group_by: 'Grouper par',
  order_type: 'Type de commande',
  chart_type: 'Type de graphique',
  charts: 'Graphiques',
  quantity_by_order_type: 'Quantité par type de commande',
  revenue: "Chiffre d'affaires",
  articles_sold: 'Articles vendus',
  top_article: 'Article phare',
  best_customer: 'Meilleur client',
  calculate: 'Calculer',
  profile: 'Profil',
  add_and_customize: 'Ajouter & Personnaliser',
  profile_name: 'Nom du profil',
  revenue_after_discount: 'CA (ap. rem.)',
  revenue_after_discount_hint: "Chiffre d'affaires après remise, TVA exclue",
  revenue_pre_discount: 'CA (av. rem.)',
  revenue_pre_discount_hint: "Chiffre d'affaires avant remise, TVA exclue",
  produced_articles: 'Articles produits',
  total_price: 'Prix total',
  raw_material: 'Matière première',
  total_dough_produced: 'Total de pâte produite',
  produced_dough_kinds: 'Types de pâte produits',
  top_dough: 'Top-Pâte',
  total_raw_materials_used: 'Total des matières premières utilisées',
  used_raw_material_kinds: 'Types de matières premières utilisées',
  top_raw_material: 'Matière première principale',
});

export const statisticIt = t({
  statistic: 'Statistica',
  order_statistic: 'Statistica degli ordini',
  product_group: 'Gruppo di prodotti',
  marketing_group: 'Gruppo marketing',
  production_group: 'Gruppo di produzione',
  show_one_time_customers: 'Mostra clienti una tantum',
  production_statistic: 'Statistica di produzione',
  group_by: 'Raggruppa per',
  order_type: 'Tipo di ordine',
  chart_type: 'Tipo di grafico',
  charts: 'Grafici',
  revenue: 'Fatturato',
  quantity_by_order_type: 'Quantità per tipo di ordine',
  articles_sold: 'Articoli venduti',
  top_article: 'Articolo di punta',
  best_customer: 'Miglior cliente',
  calculate: 'Calcolare',
  profile: 'Profilo',
  add_and_customize: 'Aggiungi & Personalizza',
  profile_name: 'Nome profilo',
  revenue_after_discount: 'Fatturato (scont.)',
  revenue_after_discount_hint: 'Fatturato dopo lo sconto, IVA esclusa',
  revenue_pre_discount: 'Fatturato (orig.)',
  revenue_pre_discount_hint: 'Fatturato prima dello sconto, IVA esclusa',
  produced_articles: 'Articoli prodotti',
  total_price: 'Prezzo totale',
  raw_material: 'Materia prima',
  total_dough_produced: 'Totale impasto prodotto',
  produced_dough_kinds: 'Tipi di impasto prodotti',
  top_dough: 'Top-Impasto',
  total_raw_materials_used: 'Totale materie prime utilizzate',
  used_raw_material_kinds: 'Tipi di materie prime utilizzate',
  top_raw_material: 'Materia prima principale',
});
